enum TypePrevious {
  ONE_OF = 'ONE_OF',
  NO_ONE_OF = 'NO_ONE_OF',
  ALL = 'ALL',
}

export default TypePrevious;
